import React, {useContext} from 'react';
import Logo from './Logo';
import Settings from './Settings';
import {GlobalContext} from "../../context/GlobalState";

const Nav = () => {
  const {userData} = useContext(GlobalContext);

  return (
    <header className='nav'>
      <Logo/>
      <Settings email={userData && userData.email || ''}/>
    </header>
  );
};

export default Nav;
